import { heroStats } from "@/mocks/content";

export default function Hero() {
  const go = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <section id="top" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=a%20stylized%20vibrant%20anime%20ninja%20parody%20meme%20collage%20scene%20with%20fiery%20orange%20and%20golden%20energy%20whirls%2C%20playful%20cartoon%20action%20poses%2C%20comic%20style%20speed%20lines%2C%20warm%20sunset%20backdrop%2C%20bold%20ink%20outlines%2C%20joyful%20chaotic%20atmosphere%2C%20high%20detail%2C%20cinematic%20lighting&width=1800&height=1000&seq=hero-naruto-meme&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-secondary-500/40 bg-secondary-500/20 px-4 py-1.5 text-sm text-secondary-100">
          <i className="ri-fire-fill text-secondary-500"></i>
          每周爆款 · 神吐槽 · 沙雕图 · 弹幕梗
        </span>
        <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          火影黄本子
        </h1>
        <p className="mt-4 max-w-2xl text-base text-background-100 md:text-lg">
          把忍者世界玩坏的地方——魔改版解说、神吐槽合集、沙雕图集与爆笑名场面，
          每期更新高能片段，专治追番后的各种意难平。
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => go("hot")}
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            去看本期高能
          </button>
          <button
            type="button"
            onClick={() => go("gallery")}
            className="whitespace-nowrap rounded-md border border-background-100/40 bg-background-50/10 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-background-50/20"
          >
            翻翻沙雕图集
          </button>
        </div>
      </div>

      <div className="relative mx-auto w-full max-w-6xl px-4 pb-10 md:px-6">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-100/15 bg-background-50/10 p-4 text-center backdrop-blur-sm md:p-5"
            >
              <div className="font-heading text-2xl text-secondary-400 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-background-200 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}